import { useEffect } from 'react'
import PropTypes from 'prop-types'
import React from 'react'
import SpinGif from './SpinGif.webp'

const Spinner = (props) => {
  const { visible, mini, fullscreen } = props
  useEffect(() => {
    if (visible) {
      const handleKey = (e) => e.stopPropagation()
      window.addEventListener('keydown', handleKey, { capture: true })
      return () => {
        window.removeEventListener('keydown', handleKey, { capture: true })
      }
    }
  }, [visible])

  return (
    <span
      className="spinner-container"
      style={{
        display: visible ? 'flex' : 'none',
        width: mini ? `70px` : `1920px`,
        height: mini ? `70px` : `1080px`,
        paddingLeft: mini ? `32px` : `0`,
        backgroundColor: fullscreen ? `#2F3437` : `transparent`,
      }}
    >
      <img
        src={SpinGif}
        alt="loading"
        style={{
          width: mini ? `70px` : `200px`,
          height: mini ? `70px` : `200px`,
        }}
      />
    </span>
  )
}

Spinner.propTypes = {
  fullscreen: PropTypes.bool,
  mini: PropTypes.bool,
  screen: PropTypes.bool,
  visible: PropTypes.bool,
}

export default Spinner
